/** Sticky-Header-Anker: AOS-translateY am Ziel vorher finalisieren, sonst scrollt der Browser 100px zu weit. */
function getHashTarget(hash) {
    if (!hash || hash === '#') {
        return null;
    }

    try {
        return document.querySelector(hash);
    } catch {
        return null;
    }
}

function prepareAosTarget(el) {
    if (!el.hasAttribute('data-aos') && !el.classList.contains('aos-init')) {
        return;
    }

    el.classList.add('aos-animate');
    const previousTransition = el.style.transition;
    el.style.transition = 'none';
    void el.offsetHeight;
    el.style.transition = previousTransition;
}

function scrollToAnchor(el, behavior = 'smooth') {
    prepareAosTarget(el);
    el.scrollIntoView({ block: 'start', behavior });
}

function scrollToLocationHash(behavior = 'instant') {
    const target = getHashTarget(window.location.hash);
    if (!target) {
        return;
    }
    scrollToAnchor(target, behavior);
}

export default function anchorScroll() {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href*="#"]');
        if (!link || link.getAttribute('href') === '#') {
            return;
        }

        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin) {
            return;
        }
        if (url.pathname !== window.location.pathname || url.search !== window.location.search) {
            return;
        }
        if (!url.hash) {
            return;
        }

        const target = getHashTarget(url.hash);
        if (!target) {
            return;
        }

        event.preventDefault();
        history.pushState(null, '', url.hash);
        scrollToAnchor(target, 'smooth');
    });

    window.addEventListener('hashchange', () => {
        scrollToLocationHash('smooth');
    });

    if (!window.location.hash) {
        return;
    }

    requestAnimationFrame(() => scrollToLocationHash('instant'));
    window.addEventListener('load', () => scrollToLocationHash('instant'), { once: true });
}
